// Session hook — fetches current user from /api/v1/users/me
import { useEffect, useState } from 'react';
import { SessionUser } from '../types';

type SessionState =
  | { status: 'loading' }
  | { status: 'authenticated'; user: SessionUser & { bio?: string; email?: string } }
  | { status: 'unauthenticated' };

export function useSession(): SessionState {
  const [state, setState] = useState<SessionState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    fetch('/api/v1/users/me')
      .then(res => {
        if (res.status === 401) {
          if (!cancelled) setState({ status: 'unauthenticated' });
          return null;
        }
        return res.json() as Promise<{ data: SessionUser }>;
      })
      .then(json => {
        if (!cancelled && json) setState({ status: 'authenticated', user: json.data });
      })
      .catch(() => { if (!cancelled) setState({ status: 'unauthenticated' }); });
    return () => { cancelled = true; };
  }, []);

  return state;
}
